import React from "react";
import { Eye } from "lucide-react";

export default function MembersTable({ loading, members, getLevel, navigate }) {
  return (
    <div className="hidden lg:block bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100">
      <table className="w-full table-fixed">
        <thead className="bg-gradient-to-r from-blue-700 to-blue-600 text-white">
          <tr>
            <th className="p-4 text-left">Avatar</th>

            <th className="p-4 text-left">Nom</th>

            <th className="p-4 text-left">ID</th>

            <th className="p-4 text-center">Niveau</th>

            <th className="p-4 text-center">Points</th>

            <th className="p-4 text-center">Statut</th>

            <th className="p-4 text-center">Action</th>
          </tr>
        </thead>

        <tbody>
          {loading ? (
            <tr>
              <td colSpan="7" className="py-12 text-center">
                Chargement...
              </td>
            </tr>
          ) : members.length === 0 ? (
            <tr>
              <td colSpan="7" className="py-12 text-center text-gray-500">
                Aucun membre trouvé.
              </td>
            </tr>
          ) : (
            members.map((m) => (
              <tr
                key={m.id}
                className="border-t hover:bg-blue-50 hover:shadow-md transition-all duration-300"
              >
                <td className="p-4">
                  {m.avatar ? (
                    <img
                      src={m.avatar}
                      alt=""
                      className="w-14 h-14 rounded-full object-cover border-2 border-blue-600 shadow"
                    />
                  ) : (
                    <div className="w-14 h-14 rounded-full bg-blue-600 text-white flex items-center justify-center text-xl font-bold">
                      {m.prenom?.charAt(0).toUpperCase()}
                    </div>
                  )}
                </td>

                <td className="p-4">
                  <div className="font-bold">
                    {m.prenom} {m.nom}
                  </div>

                </td>

                <td className="p-4 break-all text-sm">{m.member_id}</td>

                <td className="p-4 text-center">
                  <span
                    className={`px-3 py-1 rounded-full text-white text-sm font-semibold
                    ${
                      getLevel(m.points || 0) === "Elite"
                        ? "bg-purple-600"
                        : getLevel(m.points || 0) === "Gold"
                          ? "bg-yellow-500"
                          : getLevel(m.points || 0) === "Silver"
                            ? "bg-gray-500"
                            : "bg-amber-700"
                    }`}
                  >
                    {getLevel(m.points || 0)}
                  </span>
                </td>

                <td className="p-4 text-center">
                  <span className="font-bold text-blue-700">
                    {m.points || 0}
                  </span>
                </td>

                <td className="p-4 text-center whitespace-nowrap">
                  <span
                    className={`inline-block px-3 py-1 rounded-full text-sm font-semibold ${
                      m.status === "suspended"
                        ? "bg-orange-100 text-orange-700"
                        : "bg-green-100 text-green-700"
                    }`}
                  >
                    {m.status === "suspended" ? "Suspendu" : "Actif"}
                  </span>
                </td>

                <td className="p-4 text-center">
                  <button
                    onClick={() => navigate(`/admin/member-details/${m.id}`)}
                    className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-xl transition"
                  >
                    <Eye size={18} />
                    Voir
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
